<template>
    <!-- 工船宝全国数据 -->
    <div>
        <!-- 内容 -->
        <div class="content content-chunk-box">
            <!-- 边角 -->
            <contentCorner>
                <!-- 内容 -->
                <div class="city-box">
                  <div id="map" class="my-map" >
                    <span id="txt_drawships_count"></span>
                  </div>
<!--                  <div class="map-ctrl-btns" style="float: right">-->
<!--                    <button @click="setTXMapType('1')">矢量</button>-->
<!--                    <button @click="setTXMapType('2')">卫星</button>-->
<!--                  </div>-->
                </div>
            </contentCorner>
        </div>
    </div>
</template>
<script>
import contentCorner from '../../components/common/contentCorner.vue';
export default {
    props: {
        allList: {
            type: Array,
            default() {
                return []
            }
        },
        shipList: {
            type: Array,
            default() {
                return []
            }
        },
    },
    components: { contentCorner },
    data() {
        return {
            imgList: [],
            refreshImgIng: null,   // 刷新定时器
            config: {
                data: [],
                header: [],
                rowNum: 1, //表格行
                oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
                evenRowBGC: 'rgba(26, 201, 255, 0)', //偶数行
                align: ['center'],
                waitTime: 1000 * 25,
            },
            map: null,
            markerLayer: null,
            center_lng : 120.31,
            center_lat : 29.15,
            marker: {},
            nowInfoWindow: null,
            polyLine: {},
            markerArr: [],
            laberColor: "",
            laberBackgroundColor: "",
            dataList:[]
        }
    },
    mounted() {
        // eslint-disable-next-line no-undef
      // this.initMap();
      this.initTXMap();
    },
    methods: {
      /* eslint-disable no-undef */
      initMap() {
        if (this.map != null) {
          return;
        }
        this.map = new BMap.Map("map");
        this.map.centerAndZoom(new BMap.Point(118.3024455, 25.506339), 9);
        this.map.enableScrollWheelZoom(true);//原来的滚动缩放不好用
        this.map.addControl(new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_RIGHT}));
        this.map.addControl(new BMap.MapTypeControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT}));
        this.map.addControl(new BMap.ScaleControl());
        //自定义鼠标中心滚动缩放

        //地图类型更新时，更改显示文本颜色
        this.map.addEventListener('maptypechange', (e) => {
          let mapType = e.target.getMapType();
          if (mapType == BMAP_NORMAL_MAP) {
            this.laberColor = "#000";
            this.laberBackgroundColor = "rgba(255, 255, 255, 1)";

            this.addDio(this.dataList);//刷新覆盖物
          }
          if (mapType == BMAP_HYBRID_MAP) {
            this.laberColor = "#fff";
            this.laberBackgroundColor = "rgba(0, 0, 0, 1)";
            this.addDio(this.dataList);//刷新覆盖物
          }
          if (mapType == BMAP_PERSPECTIVE_MAP) {
            this.map.setMapType(BMAP_NORMAL_MAP)
          }
        });
      },


        /**
         * 创建地图示例
         * @param {*} list
         * @param {*}
         */
        // addDio(list, isReloadShip) {
        //     // 循环创建并添加地图点
        //   if (this.markerArr.length > 0) {
        //     this.map.clearOverlays();
        //   }
        //
        //     this.markerArr = [];
        //   this.dataList = list;
        //   let date1 = new Date().getTime();
        //     //加载点图标
        //     list.forEach((data) => {
        //
        //     });
        //     for (let k = 0;k<list.length;k++){
        //       let data = list[k];
        //
        //       let iconSize = data.pileNum != undefined ? data.pileNum <= 10 ? 30 : data.pileNum <= 20 ? 40 : 40 : data.keynoteFlag == "0" ? 30 : data.keynoteFlag == "1" ? 40 : 40;
        //       let iconAnchor = new BMap.Size(iconSize / 2, iconSize)
        //
        //       const markerIcon = new BMap.Icon(data.iconUrl, new BMap.Size(iconSize,iconSize),{anchor:iconAnchor,imageSize:new BMap.Size(iconSize,iconSize)});
        //       let _marker = null;
        //       //标志
        //       if (!data.positions) {
        //         _marker = new BMap.Marker(new BMap.Point(data.coordinates[0],data.coordinates[1]),{icon: markerIcon});
        //         this.marker = _marker;
        //       }
        //       this.map.addOverlay(this.marker);
        //
        //       //折线
        //       if (data.positions) {
        //         const points = data.positions.map(pos => new BMap.Point(Number(pos[0]), Number(pos[1])));
        //         this.polyLine = new BMap.Polyline(points,{strokeColor: 'red',strokeWeight: 6});
        //         this.map.addOverlay(this.polyLine);
        //       }
        //
        //       //顶部文本
        //       let label = null;
        //       if (data.positions) {
        //         label = new BMap.Label(data.tooltipText.substring(0, 6), {
        //           position: new BMap.Point(data.positions[0][0], Number(data.positions[0][1])),
        //           offset: new BMap.Size(-15, -30)
        //         });
        //       } else {
        //         label = new BMap.Label(data.tooltipText.substring(0, 6), {
        //           position: this.marker.getPosition(),
        //           offset: new BMap.Size(-iconSize, -iconSize - 30)
        //         });
        //       }
        //
        //       label.setStyle({
        //         color: this.laberColor,
        //         backgroundColor: this.laberBackgroundColor,
        //         border: "0px solid #000",
        //         padding: "2px 5px",
        //         borderRadius: "5px",
        //         fontSize: "14px",
        //         whiteSpace: "nowrap", // 防止换行
        //         textAlign: "center"
        //       });
        //       this.map.addOverlay(label);
        //
        //       //悬停内容
        //       let infoWindow = null;
        //       if (data.positions) {
        //         infoWindow = new BMap.InfoWindow(data.popupContent,{offset: new BMap.Size(200,300)});
        //       }else {
        //         infoWindow = new BMap.InfoWindow(data.popupContent,{offset: new BMap.Size(200,300)});
        //       }
        //       infoWindow.setWidth(300);
        //       this.map.getPanes().floatShadow.style.display = 'none';//关闭阴影
        //       if (!data.positions) {
        //         // 启动闪烁动画
        //         if (data.chargeStationStatusValue == "1") {
        //           // this.marker.hd.classList.add('blink-icon');
        //           this.marker.Cc.classList.add('blink-icon');
        //           let a = 1;
        //         }
        //         this.marker.addEventListener('click', () => {
        //           //鼠标移入的时候开启提示框
        //           let bounds = this.map.getBounds();
        //           this.nowInfoWindow = infoWindow;
        //           this.map.openInfoWindow(infoWindow,new BMap.Point(bounds.getSouthWest().lng, bounds.getNorthEast().lat));
        //         });
        //
        //       }else {
        //         this.polyLine.addEventListener('click', function () {
        //           //鼠标移入的时候开启提示框
        //           let bounds = this.map.getBounds();
        //           this.nowInfoWindow = infoWindow;
        //           this.map.openInfoWindow(infoWindow,new BMap.Point(bounds.getSouthWest().lng, bounds.getNorthEast().lat));
        //         });
        //
        //       }
        //
        //       this.map.addEventListener('dragend', (e) => {
        //         let bounds = this.map.getBounds();
        //         this.map.openInfoWindow(this.nowInfoWindow,new BMap.Point(bounds.getSouthWest().lng, bounds.getNorthEast().lat));
        //       });
        //
        //       this.markerArr.push(this.marker)
        //     }
        //     console.log("耗时:"+ (new Date().getTime() - date1))
        // },

      //腾讯地图系列接口
      initTXMap() {
          this.map = L.map("map", {
            zoom: 8,
            maxZoom: 18,
            center: [25.506339, 118.3024455],
          });
          // 高德卫星底图
          let gaodeSatellite = L.tileLayer(
              'https://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}', {
                name: "底图",
                subdomains: ["1", "2", "3", "4"],
              }
          )

          // 高德矢量底图
          let gaodeVector = L.tileLayer(
              'https://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}', {
                name: "底图",
                subdomains: ["1", "2", "3", "4"],
              }
          ).addTo(this.map)

          // 高德路网注记
          let gaodeLabel = L.tileLayer(
              'https://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}', {
                name: "注记",
                subdomains: ["1", "2", "3", "4"],
              }
          ).addTo(this.map)
          let baseLayers = {
            "卫星": gaodeSatellite,
            "矢量": gaodeVector
          };
          let overlayLayers = {
            "路网": gaodeLabel
          };
          L.control.layers(
              baseLayers,        // 基础底图层（互斥切换）
              overlayLayers,     // 叠加图层（勾选显示）
              {
                position: 'topright', // 控件位置：右上角（不遮挡默认缩放控件）
                collapsed: false      // 可选：false=默认展开控件，true=默认折叠
              }
          ).addTo(this.map);

          this.markerLayer = L.layerGroup().addTo(this.map);
          this.map.attributionControl.remove();
          this.map.attributionControl.setPrefix(''); // 清空前缀
          // this.map = new TMap.Map(map,{
        //   center: new TMap.LatLng(25.506339, 118.3024455),
        //   zoom: 9
        // });
        // this.markerLayer = new TMap.MultiMarker({
        //   map: this.map,
        //   styles: {
        //     "smallChargingStation": new TMap.MarkerStyle({
        //       width: 25,
        //       height: 35,
        //       src: "../../assets/icons/120/充电站.png",
        //       anchor: {x: 16, y: 32}
        //     })
        //   }
        // });
        // this.polylineLayer = new TMap.MultiPolyline({
        //   map: this.map,
        //   styles: {
        //     'style_blue': new TMap.PolylineStyle({
        //       'color': '#3777FF', //线填充色
        //       'width': 6, //折线宽度
        //       'borderWidth': 5, //边线宽度
        //       'borderColor': '#FFF', //边线颜色
        //       'lineCap': 'butt' //线端头方式
        //     })
        //   }
        // });
        // // this.infoWindowLayer = new TMap.InfoWindow({
        // //   map: this.map, // 绑定到地图
        // //   position: new TMap.LatLng(25.506339, 118.3024455), // 初始位置（点击 Marker 后动态设置）
        // //   content: "", // 初始内容（点击 Marker 后动态更新）
        // //   offset: { x: 0, y: -30 } // 弹窗偏移（避免遮挡 Marker）
        // // });
        // // 监听 MultiMarker 点击事件，显示弹窗
        // this.markerLayer.on("click", function(e) {
        //   // e.geometry 是被点击的 Marker 几何信息
        // //   const clickedMarker = e.geometry;
        // //   if (!clickedMarker || !clickedMarker.properties) return;
        // //
        // //   // 获取 Marker 关联的文本信息
        // //   const markerTitle = clickedMarker.properties.title;
        // //   const markerContent = clickedMarker.properties.content;
        // //
        // //   // 组装弹窗文本内容（支持 HTML 格式）
        // //   const windowContent = `
        // //     <div style="padding: 10px; min-width: 200px;">
        // //         <h3 style="margin: 0 0 8px; font-size: 16px; color: #333;">${markerTitle}</h3>
        // //         <p style="margin: 0; font-size: 14px; color: #666;">${markerContent}</p>
        // //     </div>
        // // `;
        // //
        // //   // 更新 InfoWindow 位置和内容，并显示
        // //   $scope.infoWindow.setPosition(clickedMarker.position); // 弹窗位置与 Marker 一致
        // //   $scope.infoWindow.setContent(windowContent); // 设置弹窗文本
        // //   $scope.infoWindow.show(); // 显示弹窗
        // });
        // this.polylineLayer.on("click", function(e) {
        //   // e.geometry 是被点击的 Marker 几何信息
        // //   const clickedMarker = e.geometry;
        // //   if (!clickedMarker || !clickedMarker.properties) return;
        // //
        // //   // 获取 Marker 关联的文本信息
        // //   const markerTitle = clickedMarker.properties.title;
        // //   const markerContent = clickedMarker.properties.content;
        // //
        // //   // 组装弹窗文本内容（支持 HTML 格式）
        // //   const windowContent = `
        // //     <div style="padding: 10px; min-width: 200px;">
        // //         <h3 style="margin: 0 0 8px; font-size: 16px; color: #333;">${markerTitle}</h3>
        // //         <p style="margin: 0; font-size: 14px; color: #666;">${markerContent}</p>
        // //     </div>
        // // `;
        // //
        // //   // 更新 InfoWindow 位置和内容，并显示
        // //   $scope.infoWindow.setPosition(clickedMarker.position); // 弹窗位置与 Marker 一致
        // //   $scope.infoWindow.setContent(windowContent); // 设置弹窗文本
        // //   $scope.infoWindow.show(); // 显示弹窗
        // });
      },
      addTXMarker(list, isReloadShip) {
        //先清除历史marker
        this.markerLayer.clearLayers();

        for (let k = 0;k<list.length;k++){
          let data = list[k];

          let iconSize = data.pileNum != undefined ? data.pileNum <= 10 ? 30 : data.pileNum <= 20 ? 40 : 40 : data.keynoteFlag == "0" ? 30 : data.keynoteFlag == "1" ? 40 : 40;
          // let iconAnchor = new BMap.Size(iconSize / 2, iconSize)

          // const markerIcon = new BMap.Icon(data.iconUrl, new BMap.Size(iconSize,iconSize),{anchor:iconAnchor,imageSize:new BMap.Size(iconSize,iconSize)});
          let _marker = null;
          //标志
          if (!data.positions) {
            let className = "";
            if (data.chargeStationStatusValue == "1") {
              className = "blink-icon";
            }
            let icon = L.icon({
              iconUrl: data.iconUrl,
              iconSize: [iconSize,iconSize],
              iconAnchor: [iconSize / 2, iconSize],
              className: className
            })
            let title = data.tooltipText.substring(0, 6);

            let marker = L.marker([data.coordinates[1], data.coordinates[0]], {icon: icon})
                .bindTooltip(data.tooltipText.substring(0, 6),{permanent: true,direction: 'top',offset: [-iconSize/4, -iconSize]})
                .bindPopup(data.popupContent, {offset: [-iconSize / 2, -iconSize]})
                .addTo(this.markerLayer);
          }

          //折线
          if (data.positions) {
            let latlngs =
                L.polyline(data.positions, {color: 'blue'}).addTo(this.markerLayer);
          }

        }
      },
      setMapCenter(placeName, zoom) {
        if (placeName) {
          console.log(placeName);
          // 通过天地图行政区划搜索API获取地名对应的经纬度
          const tiandituKey = '2d9073c8d2098dc56aeafc5002fe5ef5';
          const url = `https://api.tianditu.gov.cn/geocoder?ds={"keyWord":"${placeName}"}&tk=${tiandituKey}`;
          fetch(url)
            .then((response) => response.json())
            .then((res) => {
              if (res.status === '0' && res.location) {
                const lat = Number(res.location.lat);
                const lng = Number(res.location.lon);
                console.log(lat, lng);
                this.map.setView([lat, lng], zoom);
              } else {
                console.warn('天地图行政区划搜索无结果:', res);
              }
            })
            .catch((err) => {
              console.error('天地图行政区划搜索请求失败:', err);
            });
        } else {
          this.map.setView([29.15, 120.31], 6);
        }
      }
      /* eslint-enable no-undef */
    }
}
</script>
<style lang="scss">
img[src="http://api.map.baidu.com/images/iw3.png"] {
  // content: url('../images/iw3.png');
  width:1px !important;
  height: 1px !important;
}

img[src="https://api.map.baidu.com/images/iw3.png"] {
  opacity: 0.7;
  // margin-top: -692px !important;
  filter: alpha(opacity=70);
  // content: url('../images/iw3.png');
  width:1px !important;
  height: 1px !important;
}

.overtop{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999999;
}

/* 定义闪烁动画 */
@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}

.blink-icon {
  animation: blink 1s infinite !important;
  background-image: none !important;
}
.blink-icon > div {
  animation: inherit !important;
}
</style>
<style lang="scss" scoped>
.content {
    height: 100%;

}

.city-box {
    position: relative;
    overflow: hidden;
    height: 920px;
    padding: 20px;

}

.screen {
    &-box {
        display: flex;
    }

    &-item {
        height: 36px;
        background: #003168;
        border: 1px solid #054589;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #00A4FF;
        line-height: 36px;
        text-align: center;
        margin-left: 10px;
        padding: 0 10px;
        cursor: pointer;

        &.active {
            color: #FFF;
            box-shadow: inset 0px -5px 20px 0px rgba(0, 164, 255, 0.3803921569);
        }
    }
}

.child-head {
    display: flex;
    justify-content: space-between;
    height: 40px;
    align-items: flex-end;
    padding-right: 20px;
}

::v-deep .dv-scroll-board .rows .ceil {
    width: 100%;
}

.my-map {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: none;
    background-color: #A3CCFF;
}

// 地图右下角按钮组样式
.map-ctrl-btns {
  position: absolute; // 基于.city-box绝对定位
  right: 20px; // 距离右侧20px（可调整）
  bottom: 20px; // 距离底部20px（可调整）
  z-index: 1000; // 确保浮在地图上层（大于地图层级）
  display: flex; // 按钮横向排列
  gap: 10px; // 按钮之间间距
}
.map-ctrl-btns button {
  padding: 8px 16px;
  border: 1px solid #00A4FF;
  border-radius: 4px;
  background: rgba(0, 31, 104, 0.8); // 半透明背景，不遮挡地图
  color: #fff;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #00A4FF;
    opacity: 0.9;
  }
}

.box {
    font-family: Arial;
    font-size: larger;
    background-color: #1d374c;
    color: #fff;
    padding: 10px;
    border-radius: 12px;

    .title {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        text-align: center;
    }

    .field {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 4px;
    }
}
::v-deep .leaflet-tooltip {
  font-size: 1rem;
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
